import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: inline-block;
  transform: rotate(${ props => (props.up ? '270deg' : '90deg') });
`

export default ({ up }) => <Wrapper up={up}>></Wrapper>
